.attachment {
  --attachment-action-color: var(--rc-theme-color-primary-default);

  display: block;
  position: relative;
  width: 100%;
  max-width: var(--rc-theme-react-components-attachment-file-width);
}

.attachment__byte-size {
  color: var(--rc-theme-color-text-secondary);
}

.attachment--light,
.attachment--inverted {
  padding: var(--rc-theme-spacing-xs) var(--rc-theme-spacing-ms) var(--rc-theme-spacing-xs)
    calc(var(--rc-theme-spacing-ms) - var(--rc-theme-spacing-xxs));
  overflow: hidden;
  border-radius: var(--rc-theme-border-radius-base);

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--rc-theme-spacing-xxs);
    height: 100%;
    background: var(--attachment-accent);
    content: '';
  }
}

.attachment--light {
  --attachment-accent: var(--rc-theme-color-text-secondary);

  background: var(--rc-theme-color-surface-default);
}

.attachment--inverted {
  --attachment-accent: var(--rc-theme-color-surface-default);

  background: color-mix(in srgb, var(--rc-theme-color-surface-default) 10%, transparent);
  color: var(--rc-theme-color-surface-default);

  .attachment__filename {
    color: var(--rc-theme-color-surface-default);
  }

  .attachment__byte-size {
    color: color-mix(in srgb, var(--rc-theme-color-surface-default) 80%, transparent);
  }
}
